import BaseProxy from "../../base-proxy";

/**
 * @class GetChargedAmountProxy
 * @description Class used for communicating GET requests for charged amounts during onboarding.
 * @author Koh Keng Hong
 * @version 1.0
 * @since December 13, 2018
 */
export default class GetChargedAmountProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let addCoupon = "";
    let xeroSubcriptionOnly = "";
    if (input.couponEnabled) {
      addCoupon = "?addCoupon=true";
    }
    if (input && input.xeroSubcriptionOnly) {
      xeroSubcriptionOnly = `${addCoupon != "" ? "&" : "?"}xeroSubcriptionOnly=true`;
    }
    let endpointUrl = `${backendUrl}/companies/${input.id}/charge-amount${addCoupon}${xeroSubcriptionOnly}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
